module.exports = __webpack_public_path__ + "static/media/chevron-grey.ecff8e3c.svg";